import { $authHost, $host } from ".";

export type GetClientResponse = {
  result: boolean;
  data: {
    id: string;
    last_name: string;
    name: string;
    second_name: string;
    email: string;
    phone: string;
    birthday: string;
    sex: number;
    club: {
      id: string;
      name: string;
    };
    cards: Array<{
      id: string;
      number: string;
    }>;
    promocodes: Array<{
      id: string;
      code: string;
    }>;
    tags: Array<string>;
    edit_allowed: boolean;
    auth_message: string;
    id_cards: Array<string>;
    photo: string | null;
    appointments_to_rate: Array<{
      id: string;
      date: string;
    }>;
    cars: Array<{
      id: string;
      number: string;
    }>;
    certificates: Certificates[];
  };
};

export type PostAuthClientsResponse = {
  result: boolean;
  data: {
    user_token: string;
    id: string;
    user_tokens: Array<string>;
  };
};
export type Certificates = {
  id: string;
  name: string;
  end_date: string;
};
export const confirmPhone = async (phone: string) => {
  const response = await $host.post("/confirm_phone", {
    phone,
    auth_type: "sms",
  });
  return response.data.result;
};

export const confirmPhoneCode = async (phone: string, code: string) => {
  const response = await $host.post("/confirm_phone", {
    phone,
    auth_type: "sms",
    confirmation_code: code,
  });
  localStorage.setItem("pass_token", response.data.data.pass_token);
  return response;
};

export const setPasswordReg = async (phone: string, pass: string, token: string) => {
  return $host.post("/password", {
    phone,
    password: pass,
    pass_token: token,
  });
};

export async function authClient(phone: string, password: string) {
  return $host.post("/auth_client", { phone, password });
}

export async function getClient(usertoken?: string) {
  const response = await $authHost.request<GetClientResponse>({
    url: "/client",
    ...(usertoken && {
      headers: { usertoken: usertoken },
    }),
  });
  return response;
}

export async function authClients(phone?: string, password?: string) {
  return $host.request<PostAuthClientsResponse>({
    method: "POST",
    url: "/auth_client_new",
    data: {
      phone,
      password,
    },
  });
}
